import { motion, AnimatePresence } from 'motion/react';
import { WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNetwork } from './NetworkProvider';

/**
 * ============================================
 * Offline Banner Component
 * ============================================
 *
 * Displays a banner at the top when network is offline.
 * Animates in/out smoothly.
 */

export function OfflineBanner() {
  const { t } = useTranslation();
  const { isOnline } = useNetwork();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="overflow-hidden"
        >
          <div className="flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-white">
            <WifiOff className="h-4 w-4" />
            <span className="text-sm font-medium">{t('errors:network.offline')}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default OfflineBanner;
